import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import Button from '@mui/material/Button'

import { BaseIconButtonProps } from '../types'

/**
 *
 * @description A button with an arrow forward icon on the right.
 *
 */
const ArrowButton = ({ ...props }: BaseIconButtonProps) => (
  <Button endIcon={<ArrowForwardIcon />} {...props} />
)

export default ArrowButton
